import { Button, Form, Input, Typography } from "antd";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import bevzLogo from "../../assets/v2/bevzLogo.png";
import { postResetPassword } from "../../components/apiRepository/DynamodbRepository";
import style from "./ChangePassword.module.css";
import ErrorHandler from "../../helpers/ErrorHandler";

const { Title, Text, Paragraph } = Typography;

export default function ResetPasswordForm() {
  let { id, token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const res = await postResetPassword({
        password: values.password,
        id,
        token,
      });

      if (res?.errors?.length > 0) {
        throw new Error(res?.errors?.[0] || "Request Failed.");
      }

      const params = new URLSearchParams();
      params.set("email", values.email);

      navigate(`./success?${params.toString()}`);
    } catch (error) {
      setLoading(false);

      console.error(error?.response?.data);

      if (
        error?.response?.data?.errors?.includes(
          "New password should not be the same as current password",
        )
      ) {
        form.setFields([
          {
            name: "password",
            errors: ["You cannot use your old password."],
          },
        ]);
        return;
      }

      setError(() =>
        ErrorHandler.handleErrors(
          error?.response?.data?.errors || error?.message || "Request Failed.",
        ),
      );
    }
  };

  return (
    <>
      <div style={{ marginBottom: "1.25rem" }}>
        <img alt="Bevz" src={bevzLogo} width="171px" height="115px" />
      </div>
      <Title style={{ fontSize: "30px", margin: 0, textAlign: "center" }}>
        Set your new password
      </Title>
      <Paragraph
        style={{
          color: "#515151",
          fontSize: "16px",
          textAlign: "center",
          marginBottom: "3.125rem",
        }}
      >
        Your new password must be different from your previous one.
      </Paragraph>

      <Form
        form={form}
        autoComplete="off"
        requiredMark={false}
        layout="vertical"
        style={{ width: "100%" }}
        onFinish={handleSubmit}
      >
        <Form.Item
          hasFeedback
          name="password"
          label="New Password"
          required
          rules={[
            { required: true, message: "This is a required field." },
            { min: 8, message: "Password must be at least 8 characters." },
          ]}
        >
          <Input.Password placeholder="" size="large" />
        </Form.Item>

        <Form.Item
          dependencies={["password"]}
          hasFeedback
          name="confirmpassword"
          label="Confirm Password"
          required
          rules={[
            { required: true, message: "This is a required field." },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Password does not match!"));
              },
            }),
          ]}
          style={{ marginBottom: "3.125rem" }}
        >
          <Input.Password placeholder="" size="large" />
        </Form.Item>

        <Paragraph style={{ textAlign: "center", marginBottom: 0 }}>
          <Text type="danger">{error}</Text>
        </Paragraph>

        <Form.Item label={null}>
          <Button
            size="large"
            htmlType="submit"
            className={style.BlueBrandButton}
            iconPosition="end"
            loading={loading}
          >
            Reset Password
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
